module.exports = __webpack_public_path__ + "assets/img/18_1847_big.d9078a78.jpg";